module.exports = __webpack_public_path__ + "static/media/teafloor1.e4659923.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/teafloor1.jpg
// module id = 452
// module chunks = 0